export default __webpack_public_path__ + "static/media/IMG_4554-min.810f1df0.JPG";